
import { http } from "../../../shared/api/http";
import { AuthRequest, LoginResponse } from "../models/type";

export async function authStaff(data:AuthRequest,): Promise<LoginResponse> {
  const res = await http.post(`/auth/staff/login`,data);
  return res.data;
}